module.exports = __webpack_public_path__ + "static/media/roulette_casino_win.af50f4a3.mp3";